export default "__VITE_ASSET__84de7c62__"